export default __webpack_public_path__ + "static/media/4395.065bab74.png";